import { createContext, useContext } from "react";

export const PermissionContext = createContext({ permissions: {}, permissionsLoaded: false });
export const usePermissions = () => useContext(PermissionContext);